import type { SVGProps } from 'react';

export const SuccessIcon = ({
  className,
  ...props
}: SVGProps<SVGSVGElement>) => (
  <svg
    className={className}
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <circle
      cx="12"
      cy="12"
      r="10"
      fill="#234B67"
      stroke="#234B67"
      strokeWidth={4}
    />
    <path
      d="M 7 12 L 10 15 L 17 9"
      fill="none"
      stroke="white"
      strokeWidth={3}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const ErrorIcon = ({ className, ...props }: SVGProps<SVGSVGElement>) => (
  <svg
    className={className}
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <circle
      cx="12"
      cy="12"
      r="10"
      fill="#FF4C52"
      stroke="#FF4C52"
      strokeWidth={4}
    />
    <path
      d="M 8 8 L 16 16"
      fill="none"
      stroke="white"
      strokeWidth={3}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M 16 8 L 8 16"
      fill="none"
      stroke="white"
      strokeWidth={3}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const CloseIcon = ({ className, ...props }: SVGProps<SVGSVGElement>) => (
  <svg
    className={className}
    viewBox="0 0 16 16"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M 3 3 L 13 13"
      fill="none"
      stroke="#234B67"
      strokeWidth={2}
      strokeLinecap="round"
    />
    <path
      d="M 13 3 L 3 13"
      fill="none"
      stroke="#234B67"
      strokeWidth={2}
      strokeLinecap="round"
    />
  </svg>
);
